import { log } from "../../../engine/logger/logger";
import { TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import { Hands, WieldMode } from "../../actors/Actor";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";
import { getActorArmor, hasStrength } from "../../items/formulas";
import {
  drawAttackDetails,
  drawShieldDetails,
} from "./wieldable/attackDetails";

export const EquipmentPanel: ComponentF<void> = (C) => {
  let y = C.bounds.y + 2;
  const twoHanded = gameData.player.wielding.mode === WieldMode.twoHanded;
  const left = gameData.player.wielding.left;
  const right = gameData.player.wielding.right;

  y += C.display.drawText(C.bounds.x, y, "Wielding:");

  const leftColor = !left ? Colors.B_GREY_2 : Colors.B_GREY_5;
  const leftString = `L: %c{${leftColor}}${left?.breed.logName || "None"} ${
    left && twoHanded ? "(2h)" : ""
  }`;
  y += C.display.drawText(C.bounds.x, y, leftString);

  const rightColor =
    !right || (twoHanded && left) ? Colors.B_GREY_2 : Colors.B_GREY_5;
  const rightString = `R: %c{${rightColor}}${right?.breed.logName || "None"} ${
    right && !left && twoHanded ? "(2h)" : ""
  }`;
  y += 1 + C.display.drawText(C.bounds.x, y, rightString);

  if (twoHanded) {
    const attackingWeapon =
      gameData.player.wielding.left || gameData.player.wielding.right;
    if (attackingWeapon) {
      const twoHandAttack = attackingWeapon.breed.attacks?.twohanded;
      if (twoHandAttack) {
        if (twoHandAttack.blocks) {
          y += C.display.drawText(
            C.bounds.x,
            y,
            "Two Handed Block",
            C.bounds.w
          );
          y += drawShieldDetails(
            C.display,
            gameData.player,
            twoHandAttack,
            C.bounds.x,
            y,
            C.bounds.w,
            hasStrength(gameData.player, twoHandAttack)
              ? Colors.B_GREY_5
              : Colors.B_GREY_4
          );
        } else {
          y += C.display.drawText(
            C.bounds.x,
            y,
            "Two Handed Attack",
            C.bounds.w
          );
          y += drawAttackDetails(
            C.display,
            gameData.player,
            twoHandAttack,
            C.bounds.x,
            y,
            C.bounds.w,
            hasStrength(gameData.player, twoHandAttack)
              ? Colors.B_GREY_5
              : Colors.B_GREY_4
          );
        }
      }
    }
  } else {
    if (left && left.breed.attacks?.onehanded) {
      const lAttack = left.breed.attacks.onehanded;
      const lColor =
        gameData.player.wielding.activeHand === Hands.LEFT
          ? hasStrength(gameData.player, lAttack)
            ? Colors.B_GREY_5
            : Colors.B_GREY_4
          : Colors.B_GREY_2;

      if (lAttack.blocks) {
        y += C.display.drawText(
          C.bounds.x,
          y,
          `%c{${Colors.RED_4}}1%c{${lColor}} Left Hand Block`,
          C.bounds.w
        );
        y += drawShieldDetails(
          C.display,
          gameData.player,
          left.breed.attacks.onehanded,
          C.bounds.x,
          y,
          C.bounds.w,
          lColor
        );
        y += 1;
      } else {
        y += C.display.drawText(
          C.bounds.x,
          y,
          `%c{${Colors.RED_4}}1%c{${lColor}} Left Hand Attack`,
          C.bounds.w
        );
        y += drawAttackDetails(
          C.display,
          gameData.player,
          left.breed.attacks.onehanded,
          C.bounds.x,
          y,
          C.bounds.w,
          lColor
        );
        y += 1;
      }
    }
    if (right && right.breed.attacks?.onehanded) {
      const rAttack = right.breed.attacks.onehanded;
      const rColor =
        gameData.player.wielding.activeHand === Hands.RIGHT
          ? hasStrength(gameData.player, rAttack)
            ? Colors.B_GREY_5
            : Colors.B_GREY_4
          : Colors.B_GREY_2;

      if (rAttack.blocks) {
        y += C.display.drawText(
          C.bounds.x,
          y,
          `%c{${Colors.RED_4}}2%c{${rColor}} Right Hand Block`,
          C.bounds.w
        );
        y += drawShieldDetails(
          C.display,
          gameData.player,
          rAttack,
          C.bounds.x,
          y,
          C.bounds.w,
          rColor
        );
      } else {
        y += C.display.drawText(
          C.bounds.x,
          y,
          `%c{${Colors.RED_4}}2%c{${rColor}} Right Hand Attack`,
          C.bounds.w
        );
        y += drawAttackDetails(
          C.display,
          gameData.player,
          rAttack,
          C.bounds.x,
          y,
          C.bounds.w,
          rColor
        );
      }
    }
  }

  C.handlers.keypress = (key: string) => {
    if (key === "1") {
      gameData.player.wielding.activeHand = Hands.LEFT;
      if (gameData.player.wielding.left?.breed.attacks?.onehanded.blocks) {
        log("Shield Active, Move into enemy to block all incoming attacks");
      }
      return true;
    } else if (key === "2") {
      gameData.player.wielding.activeHand = Hands.RIGHT;
      if (gameData.player.wielding.right?.breed.attacks?.onehanded.blocks) {
        log("Shield Active, Move into enemy to block all incoming attacks");
      }
      return true;
    }
    return false;
  };

  return [
    createElement(
      TextType,
      { x: 0, y: 0, w: C.bounds.w - 2, h: 1 },
      {
        title: `Armor: ${
          gameData.player.wearing.armor?.breed.logName || "None"
        } (${getActorArmor(gameData.player)})`,
      }
    ),
  ];
};
